import React from 'react';
import { Link } from 'react-router-dom';
import { 
  BookOpenIcon,
  ArrowLeftIcon,
  MagnifyingGlassIcon
} from '@heroicons/react/24/outline';
import { PublicTopic } from '@/types/blog';

interface EmptyTopicStateProps {
  topic: PublicTopic;
  className?: string;
}

export const EmptyTopicState: React.FC<EmptyTopicStateProps> = ({ 
  topic,
  className = '' 
}) => {
  return (
    <div className={`eh-panel eh-panel-cream border border-eh-border shadow-eh-soft p-8 text-center ${className}`}>
      {/* Icon */}
      <div className="mx-auto w-16 h-16 bg-m2-surface-high rounded-full flex items-center justify-center mb-6">
        <BookOpenIcon className="w-8 h-8 text-m2-outline" />
      </div>
      
      {/* Heading */}
      <h3 className="text-xl font-semibold text-m2-on-surface mb-3">
        No Articles Yet in "{topic.title}"
      </h3>
      
      {/* Description */}
      <div className="max-w-md mx-auto">
        <p className="text-m2-on-surface-variant mb-2">
          This topic doesn't have any published articles yet.
        </p>
        {topic.description && (
          <p className="text-sm text-m2-on-surface-variant mb-6">
            {topic.description}
          </p>
        )}
      </div>
      
      {/* Actions */}
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
        {/* Back to main blog */}
        <Link
          to="/blog"
          className="eh-btn text-sm"
        >
          <ArrowLeftIcon className="w-4 h-4 mr-2" />
          Back to Blog
        </Link>
        
        {/* Explore other topics */}
        <Link
          to="/blog"
          className="eh-btn-secondary text-sm"
        >
          <MagnifyingGlassIcon className="w-4 h-4 mr-2" />
          Explore Other Topics
        </Link>
      </div>
      
      {/* Suggestion */}
      <div className="mt-8 pt-6 border-t border-m2-outline-variant">
        <p className="text-sm text-m2-on-surface-variant">
          Articles for this topic will appear here once they're published. 
          Check back soon or explore other educational content on our blog.
        </p>
      </div>
    </div>
  );
};

export default EmptyTopicState;